import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=089f6570&scoped=true&"
import script from "./LandingView.vue?vue&type=script&lang=ts&"
export * from "./LandingView.vue?vue&type=script&lang=ts&"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=089f6570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f6570",
  null
  
)

export default component.exports